module.exports = __webpack_public_path__ + "img/12217_12.6fb6dff0.png";